import { render, staticRenderFns } from "./BaseAuthorization.vue?vue&type=template&id=7e8b5cf8&"
import script from "./BaseAuthorization.vue?vue&type=script&lang=js&"
export * from "./BaseAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports